const defineContextualMenuSpec = (params) => {
  return {
    ...params
  };
};
const ContextualMenuSpecs = {
  addNode: defineContextualMenuSpec({
    name: "addNode",
    char: "/",
    placeholder: "Type to filter...",
    autoSelect: true,
    optionalCharWhenSummoned: true,
    hideNodeControls: true
  }),
  // mention: defineContextualMenuSpec({
  //   name: 'mention',
  //   char: '@',
  //   itemName: 'person',
  //   itemNamePlural: 'people',
  //   autoSelect: false,
  // }),
  // tag: defineContextualMenuSpec({
  //   name: 'tag',
  //   char: '#',
  //   itemName: 'tag',
  //   itemNamePlural: 'tags',
  //   autoSelect: false,
  // }),
  linkToItem: defineContextualMenuSpec({
    name: "linkToItem",
    char: "[[",
    autoSelect: true,
    hideNodeControls: true
  }),
  modifyItem: defineContextualMenuSpec({
    name: "modifyItem",
    autoSelect: true,
    customSelector: '[data-node-drag-handle="true"]',
    overlay: true
  })
};

export { ContextualMenuSpecs };
//# sourceMappingURL=ContextualMenuConfig.js.map
